<template>
    <v-app layout="column" :class="{'bg-container' : hasBackground}" style="width: 100%">
        <vue-snotify></vue-snotify>
        <router-view name="top"></router-view>
        <div layout="row" :class="{'bg-transparent' : hasBackground, 'ml10-pc' : hasBackground, 'pb20-pc' : hasBackground}" flex>
            <router-view v-if="!$vuetify.breakpoint. smAndDown" name="sidenav" class="hidden-sm-and-down mt10-pc ml10-pc mr10-pc bg-white"></router-view>
            <router-view v-if="!loading" name="body"  :class="{'mt10-pc' : hasBackground, 'mr10-pc' : hasBackground}" class="pabody-mobile" flex></router-view>
        </div>
        <router-view name="footer" class="bg-white"></router-view>
    </v-app>
</template>

<script>
    import EventBus from '~/plugins/eventbus'

    export default {
        name: 'App',
        data() {
            return {
                loading: true,
            }
        },

        mounted() {
            EventBus.$on('notifyError', (e) => {
                this.$snotify.error(e);
            })
            EventBus.$on('addDestination', () => {
                let dest = this.$store.state.destination;
                if(!dest || dest == '/' || dest == '/login'){
                    this.$store.commit('ADD_DESTINATION', this.$route.path);
                }
            })

            this.$nextTick(() => {
                this.loading = false;
            });
        },
        computed: {
            hasBackground(){
                if(this.$route.name && this.$route.name.indexOf('login') != 0 && this.$route.name.indexOf('reset-password') != 0){
                    return true;
                }
                return false;
            }
        },
        methods: {

        }
    }
</script>
<style>
.application {
  font-family: Lato;
}
.application a {
  color: #589c8f;
}
.application-wrap {
  width: 100%;
}
.theme--light.application {
  background: url('/long.png') no-repeat top center;
  background-size: 100%;
  position: relative;
}
.bg-transparent {
  background-color: rgba(241, 241, 241, 0.7);
}
.bg-white {
  background-color: rgba(255, 255, 255, 0.95);
}
.v-list__tile__action,
.v-list__tile__avatar {
  min-width: unset;
}
.v-select-list > .v-list > div > .v-list__tile--link {
  color: black;
}
.no-twinkle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.v-text-field.v-text-field--solo
  .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-select__selections {
  max-height: 32px;
  overflow: auto;
}
</style>